import React, { useState } from 'react';
import DefaultLoader from '../../../components/loader/DefaultLoader';
import Form from 'react-bootstrap/Form';
import SeriesBatterList from '../../../components/playerList/SeriesBatterList';
import {teamListObj} from '../../../utils/team/teamSetting';
import { useTranslation } from 'react-i18next';

function NextBatter({teamObj, checked, profile}) {
    let [batterTeamObj, setBatterTeamObj] = useState(teamObj);
    const { t } = useTranslation();
    let useLang = localStorage.getItem('language');

    if(batterTeamObj['teamId'] === 0) {
        return (
            <>
            <div className="boxTitle">
                {t('opposingBatter')} : {batterTeamObj['teamName']}
            </div>
            <SeriesBatterList teamObj={batterTeamObj} title={'다음 시리즈'}
             checked={checked} profile={profile}/>
            </>
        )
    }

    let teamList = teamListObj();

    function nextTeamSelectHandler(event) {
        let type = event.target.value;
        let index = event.nativeEvent.target.selectedIndex;
        let teamName = event.nativeEvent.target[index].text;

        setBatterTeamObj({
            teamId: type, teamName
        });
    }

    return (
        <>
        <div style={{position:'absolute', top: '-35px'}}>
            <Form.Group onChange={nextTeamSelectHandler} style={{display:'inline-block', height: '29px'}}>
                <Form.Select size="sm" defaultValue={batterTeamObj['teamId']}>
                {
                    teamList.map((item) => (
                        <option value={item['teamId']} key={item['teamId']}>
                            {useLang === "en" ? item['teamEngName'] : item['teamName']}
                        </option>
                    ))
                }
                </Form.Select>
            </Form.Group>
        </div>
        <div className="boxTitle">
            {t('opposingBatter')} : {batterTeamObj['teamName']}
        </div>
        <SeriesBatterList teamObj={batterTeamObj} title={'다음 시리즈'}
        checked={checked} profile={profile}/>
        </>
    )
}

export default NextBatter;